import { SliceProps } from "@/Slice/index"
import { GRichText } from "@/components"
import { isFilled } from "@prismicio/helpers"

export const ServicePageContent = ({ slice: { primary }, className }: SliceProps<"service_page_content">) => (
    <div className={className}>
        {isFilled.title(primary.content_title) ? (
            <div className="mb-7.5">
                <GRichText field={primary.content_title} />
            </div>
        ) : null}

        <GRichText field={primary.content_rich_text} />
    </div>
)
